import antdEs from "antd/lib/locale/es_ES";
import appLocaleData from "react-intl/locale-data/es";
import esMessages from "../locales/es.json";
// Anything not translated yet falls back to English instead of showing the raw key.
import enMessages from "../locales/en.json";
import 'moment/locale/es';

const EsLang = {
  messages: {
    ...enMessages,
    ...esMessages
  },
  antd: antdEs,
  locale: 'es',
  data: appLocaleData
};
export default EsLang;
